import { motion } from "framer-motion";
import {
  MapPin,
  Search,
  CalendarClock,
  Building,
  BadgeCheck,
  Handshake,
} from "lucide-react";
import { WHY_CHOOSE } from "@/data/site";

const ICONS = [MapPin, Search, CalendarClock, Building, BadgeCheck, Handshake];

export const WhyChooseUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-24 bg-[#0f2452] text-white relative overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-[#2563eb]/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-sky-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-sky-300">
            Why Choose Us
          </span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight">
            The trusted choice across Iqaluit &amp; Nunavut
          </h2>
          <p className="mt-4 text-lg text-slate-300">
            Professional, dependable cleaning solutions tailored to your needs —
            backed by a real commitment to quality and customer satisfaction.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-6 hover:bg-white/10 transition-colors"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#2563eb]">
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="font-display mt-4 text-lg font-bold">{w.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-300">
                  {w.text}
                </p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 rounded-2xl border border-white/10 bg-white/5 p-6 sm:p-8 flex items-center gap-3">
          <MapPin className="h-6 w-6 text-sky-300 shrink-0" />
          <p className="font-display text-lg sm:text-xl font-bold text-white">
            Proudly serving Iqaluit and the territory of Nunavut
          </p>
        </div>
      </div>
    </section>
  );
};
